<alert></alert>
@if (loading || msg) {
  <div class="pagetitle"><h2>Import JSON</h2></div>
  <p class="text-center">{{ loading ? 'Loading JSON...' : msg }}</p>
  <button type="button" class="btn btn-sm btn-primary" (click)="back()">Back</button>
} @else {
  <div class="pagetitle">
    <h2>{{ record.fileName }} <span class="badge" [ngClass]="failed ? 'badge-danger' : record.status === 'completed' ? 'badge-success' : 'badge-secondary'">{{ statusLabel[record.status] }}</span></h2>
    <div>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="copy()"><i class="fa fa-fw fa-copy"></i> Copy JSON</button>&nbsp;
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="download()"><i class="fa fa-fw fa-download"></i> Download</button>
    </div>
  </div>
  <div class="small text-muted text-left mb-2">Source JSON · {{ blob.size | formatBytes }} · Uploaded {{ record.startedAt | date:'MM/dd/yyyy, h:mm a' }}</div>

  @if (failed || parseError) {
    <div class="alert alert-danger text-left d-flex align-items-start" role="alert">
      <div class="flex-grow-1">
        <strong>{{ failed ? 'Import failed' : "This file isn't valid JSON" }}</strong>
        <div class="text-break">{{ failed ? (record.errorMessage || 'The import failed.') : parseError }}</div>
        @if (failed) {
          <div class="small">The import rolled back automatically, so nothing from this file was indexed.</div>
        }
        @if (parseErrorAt) {
          <div class="small">It breaks at line {{ parseErrorAt.line }}, column {{ parseErrorAt.column }}.</div>
        }
      </div>
      @if (parseErrorAt) {
        <button type="button" class="btn btn-sm btn-outline-danger ml-3 text-nowrap" [disabled]="!viewer" (click)="reveal(parseErrorAt)">Go to line {{ parseErrorAt.line }}</button>
      }
    </div>
  }

  <div class="row">
    <div class="col-lg-8 mb-3">
      @if (tooLarge) {
        <div class="alert alert-secondary text-left d-flex align-items-center too-large">
          <span class="flex-grow-1">This file is larger than {{ maxBytes | formatBytes }}, too large to show here. Download it to see all of it.</span>
          <button type="button" class="btn btn-sm btn-outline-secondary ml-3" (click)="download()"><i class="fa fa-fw fa-download"></i> Download</button>
        </div>
      } @else {
        <div class="card json-viewer">
          <div class="card-header d-flex flex-wrap align-items-center py-1 px-2">
            <button type="button" class="btn btn-sm btn-light mr-1" [class.active]="wrap" [attr.aria-pressed]="wrap" [disabled]="!viewer" (click)="toggleWrap()"><i class="fa fa-fw fa-align-left"></i> Wrap</button>
            <button type="button" class="btn btn-sm btn-light mr-1" [disabled]="!viewer" (click)="run('editor.foldAll')"><i class="fa fa-fw fa-compress-arrows-alt"></i> Collapse all</button>
            <button type="button" class="btn btn-sm btn-light mr-1" [disabled]="!viewer" (click)="run('editor.unfoldAll')"><i class="fa fa-fw fa-expand-arrows-alt"></i> Expand all</button>
            <button type="button" class="btn btn-sm btn-light mr-1" [disabled]="!viewer || parseError || formatted" (click)="format()"><i class="fa fa-fw fa-magic"></i> Format</button>
            <button type="button" class="btn btn-sm btn-light mr-1" [disabled]="!viewer" (click)="run('actions.find')"><i class="fa fa-fw fa-search"></i> Find <span class="text-muted small">Ctrl+F</span></button>
            <button type="button" class="btn btn-sm btn-light" [disabled]="!viewer" (click)="run('editor.action.gotoLine')"><i class="fa fa-fw fa-level-down-alt"></i> Go to line <span class="text-muted small">Ctrl+G</span></button>
          </div>
          @if (!viewer) {
            <div class="small text-muted p-2">Loading editor...</div>
          }
          <div #editor style="height: 70vh"></div>
        </div>
      }
    </div>
    <div class="col-lg-4">
      @if (problems.length) {
        <div class="card mb-3 problems"><div class="card-body py-2">
          <h6 class="card-title text-danger"><i class="fa fa-fw fa-exclamation-triangle"></i> Problems <span class="float-right">{{ problems.length }}</span></h6>
          <div class="list-group list-group-flush small">
            @for (problem of problems; track $index) {
              <button type="button" class="list-group-item list-group-item-action px-0 py-1 text-left" [disabled]="!viewer" (click)="reveal(problem)">
                <i class="fa fa-fw" [ngClass]="problem.error ? 'fa-exclamation-circle text-danger' : 'fa-exclamation-triangle text-warning'"></i>
                {{ problem.message }}
                <div class="text-muted">Ln {{ problem.line }}, Col {{ problem.column }}</div>
              </button>
            }
          </div>
        </div></div>
      }
      <div class="card mb-3 import-details"><div class="card-body py-2">
        <h6 class="card-title">Import</h6>
        <dl class="row small mb-0">
          <dt class="col-6 font-weight-normal text-muted">Files</dt><dd class="col-6 text-right">{{ record.totalFileCount > 0 || record.status === 'completed' ? (record.totalFileCount | number) : '—' }}</dd>
          <dt class="col-6 font-weight-normal text-muted">Total size</dt><dd class="col-6 text-right">{{ record.totalFileSize > 0 || record.status === 'completed' ? (record.totalFileSize | formatBytes) : '—' }}</dd>
          @if (running) {
            <dt class="col-6 font-weight-normal text-muted">Progress</dt><dd class="col-6 text-right">{{ record.progress }}%</dd>
          }
          <dt class="col-6 font-weight-normal text-muted">Started</dt><dd class="col-6 text-right">{{ record.startedAt | date:'MM/dd/yyyy, h:mm a' }}</dd>
          <dt class="col-6 font-weight-normal text-muted">{{ failed ? 'Failed' : record.status === 'cancelled' ? 'Cancelled' : 'Completed' }}</dt><dd class="col-6 text-right">{{ record.completedAt ? (record.completedAt | date:'MM/dd/yyyy, h:mm a') : '—' }}</dd>
          <dt class="col-6 font-weight-normal text-muted">Duration</dt><dd class="col-6 text-right">{{ formatDurationMs(record.durationMs) }}</dd>
          <dt class="col-6 font-weight-normal text-muted">Job ID</dt>
          <dd class="col-6 text-right text-break"><code>{{ record.jobId || '—' }}</code>@if (record.jobId) {<button type="button" class="btn btn-link btn-sm text-muted p-0 ml-1 align-baseline" aria-label="Copy job ID" title="Copy job ID" (click)="copyJobId()"><i class="fa fa-fw fa-copy"></i></button>}</dd>
        </dl>
      </div></div>
      @if (summary) {
        <div class="card mb-3 media-summary"><div class="card-body py-2">
          <h6 class="card-title">Media</h6>
          <dl class="row small mb-0">
            <dt class="col-5 font-weight-normal text-muted">Label</dt><dd class="col-7 text-right">{{ summary.mediaLabel }}</dd>
            <dt class="col-5 font-weight-normal text-muted">Type</dt><dd class="col-7 text-right">{{ summary.mediaType ?? '—' }}</dd>
            <dt class="col-5 font-weight-normal text-muted">Information</dt><dd class="col-7 text-right text-break">{{ summary.mediaInformation ?? '—' }}</dd>
          </dl>
        </div></div>
        <div class="card mb-3 session-summary"><div class="card-body py-2">
          <h6 class="card-title">Backup Sessions <span class="text-muted float-right">{{ summary.sessions.length }}</span></h6>
          <div class="list-group list-group-flush small">
            @for (session of summary.sessions; track $index) {
              <button type="button" class="list-group-item list-group-item-action px-0 py-1 text-left" [disabled]="!viewer" (click)="revealSession($index)">
                <div>{{ session.label || 'No Backup Session Details Provided' }} <i class="fa fa-chevron-right text-muted float-right"></i></div>
                <div class="text-muted">{{ sessionDetails(session) }}</div>
              </button>
            }
          </div>
        </div></div>
      } @else {
        <div class="card mb-3"><div class="card-body py-2 small text-muted">
          {{ parseError ? 'The media label and backup sessions show here once the file is valid JSON.' : "This file doesn't look like a JSON media export, so there's nothing to summarize." }}
        </div></div>
      }
    </div>
  </div>
  <button type="button" class="btn btn-sm btn-primary" (click)="back()">Back</button>
}
